// Drupal 7's "Convert line breaks into HTML" filter (_filter_autop in modules/filter/filter.module),
// which the live site runs on bodies whose text format has it: a double <br /> or blank line starts
// a new paragraph, text outside blocks gets <p> tags and other line breaks become <br />.
// Ported line for line. PHP's \s and "." do not match the same characters as JavaScript's (\s takes
// no non-breaking space there, "." takes a \r), so those are spelled out.

const S = '[ \\t\\n\\r\\f\\v]';
const BLOCK = '(?:table|thead|tfoot|caption|colgroup|tbody|tr|td|th|div|dl|dd|dt|ul|ol|li|pre|select|form|blockquote|address|p|h[1-6]|hr)';

const re = (source, flags = 'g') => new RegExp(source, flags);
const PADDED_END = /\n*$/;
const DOUBLE_BR = re('<br />' + S + '*<br />');
const BLOCK_OPEN = re('(<' + BLOCK + '[^>]*>)');
const BLOCK_CLOSE = re('(</' + BLOCK + '>)');
const DUPLICATES = /\n\n+/g;
const EDGES = re('^\\n|\\n' + S + '*\\n$');
const PARAGRAPHS = re('\\n' + S + '*\\n\\n?([^\\n])');
const LIST_IN_P = /<p>(<li[^\n]+?)<\/p>/g;
const BLOCKQUOTE_IN_P = /<p><blockquote([^>]*)>/gi;
const EMPTY_P = re('<p>' + S + '*</p>\\n?');
const P_BEFORE_BLOCK = re('<p>' + S + '*(</?' + BLOCK + '[^>]*>)');
const P_AFTER_BLOCK = re('(</?' + BLOCK + '[^>]*>)' + S + '*</p>');
const LINE_BREAKS = re('(?<!<br />)' + S + '*\\n');
const BR_AFTER_BLOCK = re('(</?' + BLOCK + '[^>]*>)' + S + '*<br />');
const BR_BEFORE_END = re('<br />(' + S + '*</?(?:p|li|div|th|pre|td|ul|ol)>)');
const BARE_AMPERSAND = /&([^#])(?![A-Za-z0-9]{1,8};)/g;
// The contents of these tags, and comments, are left alone
const IGNORED = /(<!--[^\n]*?-->|<\/?(?:pre|script|style|object|iframe|svg|!--)[^>]*>)/i;

const drupalAutop = (text) => {
  // check_markup() turns Windows and Mac line ends into "\n" before any filter runs
  const chunks = String(text).replace(/\r\n?/g, '\n').split(IGNORED);
  let ignore = false;
  let ignoretag = '';
  let output = '';
  chunks.forEach((chunk, i) => {
    if (chunk === undefined) return;
    if (i % 2) {
      if (chunk.slice(0, 4) === '<!--') {
        output += chunk;
        return;
      }
      const open = chunk[1] !== '/';
      const tag = chunk.slice(open ? 1 : 2).split(/[ >]/, 1)[0];
      if (!ignore) {
        if (open) {
          ignore = true;
          ignoretag = tag;
        }
      }
      else if (!open && ignoretag === tag) {
        ignore = false;
        ignoretag = '';
      }
    }
    else if (!ignore) {
      chunk = chunk.replace(PADDED_END, '') + '\n\n';
      chunk = chunk.replace(DOUBLE_BR, '\n\n');
      chunk = chunk.replace(BLOCK_OPEN, '\n$1');
      chunk = chunk.replace(BLOCK_CLOSE, '$1\n\n');
      chunk = chunk.replace(DUPLICATES, '\n\n');
      chunk = chunk.replace(EDGES, '');
      chunk = '<p>' + chunk.replace(PARAGRAPHS, '</p>\n<p>$1') + '</p>\n';
      chunk = chunk.replace(LIST_IN_P, '$1');
      chunk = chunk.replace(BLOCKQUOTE_IN_P, '<blockquote$1><p>');
      chunk = chunk.split('</blockquote></p>').join('</p></blockquote>');
      chunk = chunk.replace(EMPTY_P, '');
      chunk = chunk.replace(P_BEFORE_BLOCK, '$1');
      chunk = chunk.replace(P_AFTER_BLOCK, '$1');
      chunk = chunk.replace(LINE_BREAKS, '<br />\n');
      chunk = chunk.replace(BR_AFTER_BLOCK, '$1');
      chunk = chunk.replace(BR_BEFORE_END, '$1');
      chunk = chunk.replace(BARE_AMPERSAND, '&amp;$1');
    }
    output += chunk;
  });
  return output;
};

export default drupalAutop;
